var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.383.068c-.428.048-.53.608-.138.79C3.695 2.46 5.925 6.05 5.925 10c0 3.95-2.23 7.54-5.68 9.144-.39.182-.291.743.14.788C6.602 20.624 12 15.935 12 10 12 4.057 6.59-.626.383.068z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMiAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzgzNDk3IDAuMDY4MzY4NUMtMC4wNDUyMDEzIDAuMTE1ODcgLTAuMTQ2NzM1IDAuNjc1ODgzIDAuMjQ0NjQ3IDAuODU3NTU0QzMuNjk1OTMgMi40NjA5MyA1LjkyNTMzIDYuMDUwMTggNS45MjUzMyAxMC4wMDAzQzUuOTI1MzMgMTMuOTUwNCAzLjY5NTkzIDE3LjUzOTYgMC4yNDQ2NDcgMTkuMTQzOEMtMC4xNDQ5OTkgMTkuMzI1NSAtMC4wNDYwNjk2IDE5Ljg4NzIgMC4zODQzNjQgMTkuOTMyMkM2LjYwMzA5IDIwLjYyMzkgMTIgMTUuOTM0NiAxMiAxMC4wMDAzQzEyIDQuMDU2OCA2LjU5MDk0IC0wLjYyNTgxNSAwLjM4MzQ5NyAwLjA2ODM2ODVaIiAvPgo8L3N2Zz4K";
export { SvgMoon as ReactComponent };